import { render } from "./ExpertStatisticsOutboundDuration.vue?vue&type=template&id=8877b714"
import script from "./ExpertStatisticsOutboundDuration.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOutboundDuration.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOutboundDuration.vue?vue&type=style&index=0&id=8877b714&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__